import React from "react";
import omit from "lodash/fp/omit";
import PropTypes from "prop-types";

export default function TagsPack({ children, css, ...props }) {
  return (
    <div
      css={{
        paddingTop: 5,
        paddingBottom: 5,
        paddingLeft: 5,
        paddingRight: 5,
        boxSizing: "border-box",
        display: "flex",
        alignItems: "center",
        flex: "1 1 auto",
        flexWrap: "wrap",
        ...css,
      }}
      {...omit("validationState", props)}
    >
      {children}
    </div>
  );
}

TagsPack.propTypes = {
  children: PropTypes.node.isRequired,
  css: PropTypes.object,
};

TagsPack.defaultProps = {
  css: {},
};
